import { Card, Modal, Spin } from "antd";
import React, { useEffect, useState } from "react";
import { FullscreenOutlined, LoadingOutlined } from "@ant-design/icons";
import { formatDate } from "../../services/util";
import { useQuery } from "react-query";
import HTTP from "../../services/httpService";
import Chart from "react-google-charts";
import { columnChartConfigurationOptions } from "../../config";

const chartConfigs = {
    ...columnChartConfigurationOptions,
    curveType: "function", // Smooths the lines
    series: {
        1: { color: "#fe8447", visibleInLegend: false },
    },
    legend: { position: "bottom" },
    hAxis: {
        slantedText: false,
        minTextSpacing: 30,
        maxAlternation: 1,
    },
    explorer: {
        actions: ["dragToZoom", "rightClickToReset"],
    },
    focusTarget: "category",
};

function YearlyChart() {
    const staff_id = localStorage.getItem("x-dashboard-staffid");
    const [chartData, setChartData] = useState([[`months`, "counts"]]);
    const [enableZoom, setEnableZoom] = useState(false);
    const [formData, setFormData] = useState({
        start_date: formatDate(new Date(new Date().getFullYear(), 0, 1)),
        end_date: formatDate(new Date(new Date().getFullYear(), 11, 31)),
        staff_id,
    });

    const {
        status,
        data: yearlySuccessRate,
        refetch,
    } = useQuery(
        "YearlyManagementChart",
        async () => {
            return await HTTP(`/dashboard/getYearlySuccessRate`, {
                ...formData,
            });
        },
        {
            enabled: false,
        },
    );

    useEffect(() => {
        refetch();
    }, [formData]);

    useEffect(() => {
        if (status === "success") {
            setChartData(
                yearlySuccessRate.data.map((e, i) => {
                    if (i == 0) return [...e, "Threshold"];
                    else return [...e, 98.15];
                }),
            );
        }
    }, [status, yearlySuccessRate]);

    return (
        <Card className="box-shadow">
            <div className="flex space-between align-center">
                <strong>Yearly Success(%)</strong>
                <FullscreenOutlined
                    style={{ fontSize: "20px" }}
                    onClick={() => {
                        setEnableZoom(true);
                    }}
                />
            </div>
            {status == "success" ? (
                <Chart
                    chartType="LineChart"
                    data={chartData}
                    options={{
                        ...chartConfigs,
                    }}
                />
            ) : (
                <Spin
                    indicator={
                        <LoadingOutlined style={{ fontSize: 48 }} spin />
                    }
                />
            )}
            <Modal
                open={enableZoom}
                destroyOnClose
                onCancel={() => {
                    setEnableZoom(false);
                }}
                width={"fit-content"}
                height={"fit-content"}
                footer={""}
            >
                <Chart
                    chartType="LineChart"
                    data={chartData}
                    options={{
                        ...chartConfigs,
                        title: "Yearly Success(%)",
                        width: "30vw",
                        height: "50vh",
                    }}
                />
            </Modal>
        </Card>
    );
}

export default YearlyChart;
